module.exports = __webpack_public_path__ + "img/session-btn.d6f83d39.svg";